var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { parse } from 'query-string';
export class TelegramPlatform {
    static getTelegram() {
        if (typeof window === 'undefined')
            return null;
        return window === null || window === void 0 ? void 0 : window.Telegram;
    }
    static getWebApp() {
        var _a;
        return (_a = TelegramPlatform.getTelegram()) === null || _a === void 0 ? void 0 : _a.WebApp;
    }
    static setTGScript() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof document === 'undefined')
                return;
            const tgScript = document.createElement('script');
            tgScript.src = 'https://telegram.org/js/telegram-web-app.js';
            document.body.appendChild(tgScript);
            tgScript === null || tgScript === void 0 ? void 0 : tgScript.addEventListener('load', () => {
                console.log('loading tg script success');
            });
        });
    }
    static _getInitData() {
        const Telegram = TelegramPlatform.getTelegram();
        if (!Telegram) {
            let locationHash = '';
            try {
                locationHash = location.hash.toString();
            }
            catch (e) {
                //
            }
            TelegramPlatform.setTGScript();
            return TelegramPlatform.urlParseHashParams(locationHash);
        }
    }
    static isTelegramPlatform() {
        try {
            const Telegram = TelegramPlatform.getTelegram();
            if (!Telegram) {
                let locationHash = '';
                try {
                    locationHash = location.hash.toString();
                }
                catch (e) {
                    //
                }
                TelegramPlatform.setTGScript();
                const initParams = TelegramPlatform.urlParseHashParams(locationHash);
                const webAppPlatform = initParams === null || initParams === void 0 ? void 0 : initParams.tgWebAppPlatform;
                return Boolean(webAppPlatform && webAppPlatform !== 'unknown');
            }
            return !!(Telegram && Telegram.WebApp.platform && Telegram.WebApp.platform !== 'unknown');
        }
        catch (error) {
            console.error('isTelegramPlatform:', error);
            return false;
        }
    }
    static urlParseHashParams(hash) {
        let locationHash = hash.replace(/^#/, '');
        const params = {};
        if (!locationHash.length) {
            return params;
        }
        if (locationHash.indexOf('=') < 0 && locationHash.indexOf('?') < 0) {
            params._path = TelegramPlatform.urlSafeDecode(locationHash);
            return params;
        }
        const qIndex = locationHash.indexOf('?');
        if (qIndex >= 0) {
            const pathParam = locationHash.substr(0, qIndex);
            params._path = TelegramPlatform.urlSafeDecode(pathParam);
            locationHash = locationHash.substr(qIndex + 1);
        }
        const query_params = TelegramPlatform.urlParseQueryString(locationHash);
        for (const k in query_params) {
            params[k] = query_params[k];
        }
        return params;
    }
    static urlSafeDecode(urlencoded) {
        try {
            urlencoded = urlencoded.replace(/\+/g, '%20');
            return decodeURIComponent(urlencoded);
        }
        catch (e) {
            return urlencoded;
        }
    }
    static urlParseQueryString(queryString) {
        const params = {};
        if (!queryString.length) {
            return params;
        }
        const queryStringParams = queryString.split('&');
        let i, param, paramName, paramValue;
        for (i = 0; i < queryStringParams.length; i++) {
            param = queryStringParams[i].split('=');
            paramName = TelegramPlatform.urlSafeDecode(param[0]);
            paramValue = param[1] == null ? null : TelegramPlatform.urlSafeDecode(param[1]);
            params[paramName] = paramValue;
        }
        return params;
    }
    static openLink(url) {
        var _a;
        (_a = TelegramPlatform.getWebApp()) === null || _a === void 0 ? void 0 : _a.openLink(url.toString());
        return null;
    }
    static close() {
        var _a;
        (_a = TelegramPlatform.getWebApp()) === null || _a === void 0 ? void 0 : _a.close();
    }
    static getInitData() {
        var _a;
        let parsedInitData;
        try {
            const initData = (_a = TelegramPlatform.getWebApp()) === null || _a === void 0 ? void 0 : _a.initData;
            if (initData) {
                parsedInitData = parse(initData);
            }
            else {
                parsedInitData = TelegramPlatform._getInitData();
            }
        }
        catch (error) {
            console.error('getInitData error: ', error);
        }
        return parsedInitData;
    }
    static getStartParam() {
        let startParam;
        try {
            const initData = TelegramPlatform.getInitData();
            startParam = initData === null || initData === void 0 ? void 0 : initData.start_param;
        }
        catch (error) {
            console.error('getStartParam error: ', error);
        }
        return startParam;
    }
    static getTelegramUserId() {
        let userId;
        try {
            const initData = TelegramPlatform.getInitData();
            if (initData === null || initData === void 0 ? void 0 : initData.user) {
                const userInfo = JSON.parse(initData.user);
                userId = String(userInfo.id);
            }
        }
        catch (error) {
            console.error('getTelegramUserId error: ', error);
        }
        return userId;
    }
}
